import MuiTimeline from "@material-ui/lab/Timeline";
import MuiTimelineConnector from "@material-ui/lab/TimelineConnector";
import MuiTimelineContent from "@material-ui/lab/TimelineContent";
import MuiTimelineDot from "@material-ui/lab/TimelineDot";
import MuiTimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import clsx from "clsx";
import { Client, SubTask, SubTaskType } from "generated/graphql";
import { useHupAdress } from "hooks/useCurrentUser";
import React from "react";
import styled from "styled-components";
import "styled-components/macro";

export const Timeline = styled(MuiTimeline)``;

export const TimelineItem = styled(MuiTimelineItem)`
  min-height: 30px;
  &.dot {
    min-height: 20px;
  }
  :before {
    content: none;
  }
`;
export const AddressContent = styled.div`
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #707070;
`;
export const NameContent = styled.div`
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #707070;
`;
export const TimelineContent = styled(MuiTimelineContent)`
  font-size: 14px;
  font-weight: 900;
  color: #707070;
  padding-top: 0px;
  margin-left: -10px;
`;

export const TimelineConnector = styled(MuiTimelineConnector)`
  width: 1px;
  &.dot {
    margin-left: 8px;
  }
`;

export const TimelineDot = styled(MuiTimelineDot)`
  height: 18px;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  box-shadow: none;
  margin: 0;
  background-color: transparent;

  &.pickup.outlined {
    color: #399ebf;
    border-color: #399ebf;
  }

  &.pickup.contained {
    background-color: #399ebf;
  }

  &.delivery.outlined {
    color: #ebae23;
    border-color: #ebae23;
  }

  &.delivery.contained {
    background-color: #399ebf;
  }
  &.done {
    color: #c9c9c9;
    border-color: #c9c9c9;
  }

  &.dot {
    height: 2px;
    width: 2px;
    padding: 0;
    margin-left: 6.75px;
  }
`;

interface SubTaskPathProps {
  subTask: SubTask;
  client: Client;
}

export default function SubTaskPath({ subTask, client }: SubTaskPathProps) {
  const clientContactName =
    client?.client_contact_firstname && `${client?.client_contact_firstname} ${client?.client_contact_lastname}`;
  const receiverFullname = `${subTask?.subtask_recipient?.receiver_firstname} ${subTask?.subtask_recipient?.receiver_lastname}`;
  const isPickup = () => subTask?.subtask_type === SubTaskType.Pickup;
  const isDelivery = () => subTask?.subtask_type === SubTaskType.Delivery;
  const defaultAdress = useHupAdress();
  return (
    <Timeline align="left">
      <TimelineItem>
        <TimelineSeparator
          css={`
            &.MuiTimelineSeparator-root {
              margin-top: -6px;
            }
          `}
        >
          <TimelineDot
            className={clsx("outlined", {
              pickup: true,
            })}
          >
            P
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <AddressContent>{isPickup() ? subTask?.subtask_address?.address : defaultAdress}</AddressContent>
          <NameContent>{isPickup() ? clientContactName : "PAPS"}</NameContent>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className="dot">
        <TimelineSeparator>
          <TimelineDot
            className={clsx("dot outlined", {
              pickup: true,
            })}
          />
          <TimelineConnector className="dot" />
        </TimelineSeparator>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot
            className={clsx("contained", {
              delivery: true,
            })}
          >
            D
          </TimelineDot>
        </TimelineSeparator>
        <TimelineContent>
          <AddressContent>{isDelivery() ? client?.client_address?.address : defaultAdress}</AddressContent>

          <NameContent>{isPickup() ? "PAPS" : isDelivery() ? receiverFullname : clientContactName}</NameContent>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}
